module.exports = function () {
  return new Worker(__webpack_public_path__ + "be2bf4c6f73a9aa9985f.worker.js");
};